ThemeJS.Archive_Items = (function ($) {
  function match_heights() {
    //[ '.headings', '.img-wrap' ].forEach( selector => {
    [".headings"].forEach((selector) => {
      let $collection = $(`.ph-archive-item ${selector}`);
      if ($collection.length) {
        $collection.matchHeight();
      }
    });
  }

  function calculate_content_expansion() {
    $(".wysiwyg-expand-wrap").each(function () {
      const $content = $(".wysiwyg-content", this);
      const style = getComputedStyle(this);
      const line_height_px = parseInt(style.getPropertyValue("line-height"));
      const max_lines = parseInt(style.getPropertyValue("--max-lines"));

      const max_height_collapsed = line_height_px * max_lines;
      const max_height_collapse_check = line_height_px * (max_lines + 1);
      const content_height = $content.height();

      this.style.setProperty(
        "--max-height-collapsed",
        `${max_height_collapsed}px`,
      );
      this.style.setProperty(
        "--max-height-collapse-check",
        `${max_height_collapse_check}px`,
      );
      this.style.setProperty("--content-height", `${content_height}px`);

      if (
        !$(this).hasClass("expanded") &&
        content_height > max_height_collapse_check
      ) {
        $(this).addClass("collapse");
      }
      $(this).toggleClass("clamped", !$(this).hasClass("expanded"));
    });
  }

  $(function () {
    match_heights();
    calculate_content_expansion();
    $(window).on("breakpoint_changed", calculate_content_expansion);

    $(document).on("click", ".wysiwyg-expand-wrap + button", function () {
      const $btn = $(this);
      const $wrap = $btn.prev(".wysiwyg-expand-wrap");

      $wrap.removeClass("clamped").toggleClass("expanded");
      setTimeout(
        function () {
          $wrap.toggleClass("clamped", !$wrap.hasClass("expanded"));
        },
        getComputedStyle($wrap.get(0)).getPropertyValue(
          "--transition-duration-ms",
        ),
      );
    });
  });

  return {
    match_heights,
    calculate_content_expansion,
  };
})(jQuery);
